import { render, staticRenderFns } from "./contact-disposition-selector.vue?vue&type=template&id=589f5339"
import script from "./contact-disposition-selector.vue?vue&type=script&lang=js"
export * from "./contact-disposition-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports